<template>
  <div class="page-main">
    <div class="page-top">
      <div class="flex flex-y-center">
        <span class="m-r-5">关联类目</span>
        <b-goods-texture
          :data.sync="categoryTextureData"
          :bao_han="['加工']"
          :isInit="false"
          :isLoadTexture="false"
          width="400px"
        />
      </div>
      <el-button type="success" size="mini" @click="itemDo()">新增设备</el-button>
    </div>

    <!-- 表格 -->
    <vxe-grid ref="refTable" v-bind="tableOptions">
      <!-- slot_header -->
      <template #header_input="{ column }">
        <c-table-header
          :title="column.title"
          :field="column.field"
          :url="headerFilterUrl"
          @change="headerFilterChange"
        />
      </template>

      <!-- slot_default -->
      <template #default_she_bei_mu_ban_list="{ row }">
        <el-link @click="itemBind(row)" type="primary">
          绑定({{ row.she_bei_mu_ban_list.length }})
        </el-link>
      </template>
      <template #default_img_list="{ row }">
        <e-upload-image v-if="row.img_list" disabled :list.sync="row.img_list" />
      </template>
      <template #default_operate="{ row }">
        <el-link type="primary" @click="itemDo(row)">编辑</el-link>
        <el-link type="danger" @click="itemDelete(row)">删除</el-link>
      </template>

      <!-- slot_pager -->
      <template #pager>
        <div></div>
        <vxe-pager v-bind="tableOptions.pagerConfig" @page-change="pageChange" />
      </template>
    </vxe-grid>

    <!-- 弹窗-增改设备 -->
    <PopupDoSheBei
      v-if="isShowPopupDoSheBei"
      :show.sync="isShowPopupDoSheBei"
      :detailId="detailId"
      @success="searchListData"
    />

    <!-- 弹窗-绑定模板 -->
    <PopupBindMuBan
      v-if="isShowPopupBindMuBan"
      :show.sync="isShowPopupBindMuBan"
      :list="detailData.she_bei_mu_ban_list"
      @success="itemBindSuccess"
    />
  </div>
</template>

<script>
export default {
  components: {
    PopupDoSheBei: () => import('./common/popup-do-she-bei'),
    PopupBindMuBan: () => import('./common/popup-bind-mu-ban')
  },
  data() {
    return {
      categoryTextureData: {
        category_list: []
      },

      filterData: {},
      headerFilterUrl: '/admin/gcvip/sheBei/searchHeard',
      tableOptions: {
        loading: false,
        size: 'mini',
        border: true,
        height: this.$util.getViewHeight() - 36 - 148,
        pagerConfig: {
          ...this.$constant.page
        },
        columns: [
          {
            fixed: 'left',
            title: '序号',
            type: 'seq',
            width: 40
          },
          { field: 'name', title: '设备名称', slots: { header: 'header_input' } },
          { field: 'type', title: '设备号', slots: { header: 'header_input' } },
          { field: 'img_list', title: '设备照片', slots: { default: 'default_img_list' } },
          {
            field: 'she_bei_mu_ban_list',
            title: '可加工商品',
            slots: { default: 'default_she_bei_mu_ban_list' }
          },
          { field: 'she_bei_fu_ze_ren', title: '设备负责人', slots: { header: 'header_input' } },
          { field: 'remark', title: '设备说明', slots: { header: 'header_input' } },
          { field: 'she_bei_price', title: '设备价格(元)', slots: { header: 'header_input' } },
          {
            field: 'she_bei_every_hour_value',
            title: '设备每小时产值(件)',
            slots: { header: 'header_input' }
          },
          {
            field: 'she_bei_every_month_value',
            title: '设备每月产值(件)',
            slots: { header: 'header_input' }
          },
          {
            field: 'she_bei_zhan_di',
            title: '设备占地使用(m³)',
            slots: { header: 'header_input' }
          },
          // { field: 'category1', title: '一级分类' },
          // { field: 'category2', title: '二级分类' },
          // { field: 'category3', title: '三级分类' },
          // { field: 'category4', title: '四级分类' },
          { title: '操作', width: 160, slots: { default: 'default_operate' } }
        ],
        data: []
      },
      isShowPopupDoSheBei: false,
      isShowPopupBindMuBan: false,
      detailId: '',
      detailData: {}
    }
  },
  computed: {
    category_names() {
      let result = this.categoryTextureData.category_list.map((item) => item.name)
      return result
    }
  },
  watch: {
    category_names(newVal, oldVal) {
      if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
        this.searchListData()
      }
    }
  },
  mounted() {
    this.searchListData()
  },
  methods: {
    // 头部筛选更新
    headerFilterChange(obj) {
      this.filterData[obj.field] = obj.value
      this.searchListData()
    },
    // 搜索列表数据
    searchListData() {
      this.tableOptions.pagerConfig.currentPage = 1
      this.getListData()
    },
    // 获取列表数据
    getListData() {
      this.tableOptions.loading = true
      let filterData = {}
      let category_len = this.category_names.length
      Object.keys(this.filterData).forEach((key) => {
        if (this.filterData[key]) filterData[key] = this.filterData[key]
      })
      if (category_len)
        filterData[`category${category_len}`] = this.category_names[category_len - 1]
      this.$api({
        method: 'post',
        url: '/admin/gcvip/sheBei/list',
        data: {
          currentPage: this.tableOptions.pagerConfig.currentPage,
          pageSize: this.tableOptions.pagerConfig.pageSize,
          filterData,
          sortData: { id: 'desc' }
        }
      })
        .then((res) => {
          if (res.status === 200) {
            this.tableOptions.data = res.data.page.list
            this.tableOptions.pagerConfig.pageSize = res.data.page.pageSize
            this.tableOptions.pagerConfig.total = res.data.page.totalRow
            this.tableOptions.pagerConfig.currentPage = res.data.page.pageNumber
          }
        })
        .catch(() => {})
        .then(() => {
          this.tableOptions.loading = false
        })
    },
    // 分页切换
    pageChange({ currentPage, pageSize }) {
      this.tableOptions.pagerConfig.currentPage = currentPage
      this.tableOptions.pagerConfig.pageSize = pageSize
      this.getListData()
    },
    // 项-增改
    itemDo(row) {
      if (row === undefined) {
        this.detailId = ''
      } else {
        this.detailId = row.id
      }
      this.isShowPopupDoSheBei = true
    },
    // 项-删除
    itemDelete(row) {
      this.$confirm('您确认要删除该数据?', '提示')
        .then(() => {
          this.$api({
            method: 'get',
            url: '/admin/gcvip/sheBei/delete',
            params: {
              id: row.id
            }
          }).then((res) => {
            if (res.data.state === 'ok') {
              this.$message.success('删除成功')
              this.getListData()
            }
          })
        })
        .catch(() => {})
    },
    // 项-绑定
    itemBind(row) {
      this.detailData = this.$util.deepCopy(row)
      this.isShowPopupBindMuBan = true
    },
    // 绑定模板-成功
    itemBindSuccess(data) {
      this.detailData.she_bei_mu_ban_list = data
      this.$api({
        method: 'post',
        url: '/admin/gcvip/sheBei/saveOrUpdate',
        data: this.detailData
      })
        .then((res) => {
          if (res.data.state === 'ok') {
            this.$message.success('绑定成功')
            this.detailData = {}
            this.getListData()
          }
        })
        .catch((error) => {
          this.$message.error(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.page-main {
  .page-top {
    position: relative;
    z-index: 9;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
  }
}
</style>
